import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import { LinkStyled } from './styles';

export default () => (
  <InformationalModule
    // configs
    sectionId='life-insurance-intro'
    moduleName='intro-module'
    moduleVariation='A'
    // content
    headingText={<>Your life insurance will be designed around <WidowBlock>your life.</WidowBlock></>}
    introContent={(
      <>
        <span id='tealium-life-insurance-module-arrangement'>
          <Typography
            align='left'
            nextElement='typography'>
            Your situation and goals are different from everyone else&#39;s, so our policies are designed differently, too. Depending on your needs, our life insurance can simply be a safety net to protect your loved ones from the unexpected. Or it can also be the foundation of a smart financial plan giving you more flexibility for important things, like paying for college, growing your business, or having more income in retirement.
          </Typography>
          <Typography
            align='left'
            nextElement='button'>
            Your Northwestern Mutual advisor can help you choose what&#39;s right for you. They&#39;ll consider your goals, priorities, and what you can spend. So you&#39;ll only get the coverage you need, and nothing you don&#39;t.
          </Typography>
        </span>
        <LinkStyled
          id='life-insurance-intro-cta-fafa'
          variant='buttonLinkPrimary'
          linkUrl='/find-a-financial-advisor/'
          ariaLabel='Get started with a financial advisor'>
          Get started
        </LinkStyled>
      </>
    )}
  />
);

